<template>
  <div class="location-tab">
    <div class="location-tab__map">

      <div v-if="hotelDescription.hotelLocation.description" class="geo__pointer">
        <svg-icon icon="location-marker" /> <span>{{ hotelDescription.hotelLocation.description }}</span>
      </div>

      <div>
        <MapWithMarker class="location-map" 
                       is-show-controls 
                       :coordinates="hotelDescription.coordinates" 
                       :map-provider="viewModel.mapProvider" 
                       :config="viewModel.mapConfiguration" />
      </div>
    </div>
    <div class="location-tab__info">
      <hotel-location-main-info 
        class="location-tab__info-panel"
        :view-model="viewModel"
      />
      <div v-if="hotelDescription.distanceToAirports.length > 0" class="hotel-location-airports location-tab__info-panel">
        <div class="bold">{{ $res.Views.Location_AirportDistance }}</div>
        <div class="hotel-location-main-info__row" v-for="distanceToAirport in hotelDescription.distanceToAirports">
          <span v-if="!!distanceToAirport.airportName" class="bold">{{ distanceToAirport.airportName }}{{" — "}}</span>
          <span v-if="showDistanceInMeters(distanceToAirport)">{{ formatDistance(distanceToAirport.distanceInMeters, ".", " ") }}</span>
          <span v-if="!!distanceToAirport.description">{{ distanceToAirport.description }}</span>
        </div>
      </div>
<!--      <hotel-location-additional-info -->
<!--        class="location-tab__info-panel"-->
<!--        :view-model="viewModel"-->
<!--      />-->
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import HotelLocationMainInfo from "./HotelLocationMainInfoComponent.vue";
import HotelLocationAdditionalInfo from "./HotelLocationAdditionalInfoComponent.vue";
import MapWithMarker from "@/common/mapWithMarker/MapWithMarker.vue";
import {formatDistance} from "@/util/distanceHelper";

export default {
  components: {
    MapWithMarker,
    SvgIcon,
    HotelLocationMainInfo,
    HotelLocationAdditionalInfo
  },
  props: {
    viewModel: {
      type: Object,
      required: true
    },
  },
  computed: {
    hotelDescription() {
      return this.viewModel.hotelDescription;
    }
  },
  methods: {
    formatDistance,
    showDistanceInMeters(distanceToAirport) {
      if (!!distanceToAirport.distanceInMeters) {
        // нет названия, но есть дескрипшн - не показываем.
        if (!distanceToAirport.airportName && !!distanceToAirport.description) {
          return false;
        }
        return true;
      }
      
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
.location-map {
  margin-top: 16px;
}

.location-tab {
  display: flex;
  gap: 16px;

  &__map {
    flex-grow: 1;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 36px;
  }
}

.block {
  background: var(--blue-200);
}

.location-tab__info-panel {
  width: 334px;
  padding: 15px 24px;
  background-color: var(--main-50);
  border-radius: var(--border-radius-md);
}

.hotel-location-airports {
  display: flex;
  flex-direction: column;
  gap: 10px; 
}
</style>